import { isBefore } from "date-fns";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export function validUntilStatusToVariant(date: Date) {
  const isBeforeToday = isBefore(date, new Date());
  return isBeforeToday ? "danger" : "default";
}
